import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const rows = [{
    sin: 'Comprás en el súper de barrio a precio de góndola',
    con: 'Sistema de 3 niveles: Mayorista / Feria / Chino'
  }, {
    sin: 'Frutas y verduras fuera de estación a cualquier precio',
    con: 'Calendario de estacionalidad — hasta 60% más barato'
  }, {
    sin: 'Compras sin lista → desperdicio del 25%',
    con: 'Lista inteligente por Bucket → cero desperdicio'
  }, {
    sin: 'La inflación te come el presupuesto mes a mes',
    con: 'Alacena de Combate — comprás hoy al precio de hoy para 3 meses'
  }, {
    sin: 'Delivery 3 veces por semana por no saber qué hay',
    con: '0-1 vez por semana — por elección, no por obligación'
  }];
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-44">
            ¿Qué agrega el Método Chango Lleno?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-45">
            El pack te dice qué cocinar. El Método te dice{' '}
            <span className="text-brand-gold font-bold" data-id="element-46">
              cómo pagar la mitad
            </span>{' '}
            por los ingredientes.
          </p>
        </div>

        <div className="bg-brand-card rounded-3xl border border-white/10 overflow-hidden" data-id="element-47">
          {/* Header Mobile */}
          <div className="grid grid-cols-2 md:hidden border-b border-white/10" data-id="element-48">
            <div className="p-4 text-center font-bold text-gray-400 bg-black/20" data-id="element-49">
              Sin Método
            </div>
            <div className="p-4 text-center font-bold text-brand-gold bg-brand-gold/5" data-id="element-50">
              Con Método
            </div>
          </div>

          {/* Header Desktop */}
          <div className="hidden md:grid grid-cols-2 border-b border-white/10" data-id="element-51">
            <div className="p-6 text-xl font-bold text-gray-400 text-center bg-black/20" data-id="element-52">
              Sin Método
            </div>
            <div className="p-6 text-xl font-bold text-brand-gold text-center bg-brand-gold/5" data-id="element-53">
              Con Método
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-white/5" data-id="element-54">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2" data-id="element-55">
                <div className="p-4 md:p-6 flex items-start gap-3 bg-black/20 md:border-r border-white/5" data-id="element-56">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-57" />
                  <span className="text-gray-300 text-sm md:text-base" data-id="element-58">
                    {row.sin}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-start gap-3 bg-brand-gold/5" data-id="element-59">
                  <Check className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-white font-medium text-sm md:text-base" data-id="element-61">
                    {row.con}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Footer */}
          <div className="p-6 md:p-8 bg-brand-gold/10 text-center border-t border-brand-gold/20" data-id="element-62">
            <p className="text-xl md:text-2xl font-bold" data-id="element-63">
              Ahorro proyectado:{' '}
              <span className="text-brand-gold" data-id="element-64">$30.000 – $58.000 ARS</span> por
              mes
            </p>
          </div>
        </div>
      </div>
    </section>;
}